import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { baseUrl, apiVersion } = CONFIG_VARS;

export const schoolsApi = createApi({
  reducerPath: "schoolsApi",
  baseQuery: createBaseQuery(baseUrl["1"], true), // Enable auth token
  endpoints: (builder) => ({
    getSchools: builder.query({
      query: (data) => {
        const searchBy = encodeURIComponent(data.searchBy || "school_name");
        const searchQuery = encodeURIComponent(data.searchQuery || "");
        return {
          url: `/${apiVersion}/onboarding/schools?page=${data.page}&limit=${
            data.limit
          }&search_by=${searchBy}&search_query=${searchQuery}`,
          method: "GET",
        };
      },
      // Disable caching to ensure loading state is always tracked
      keepUnusedDataFor: 0,
      // Force refetch on any parameter change
      forceRefetch: ({ currentArg, previousArg }) => {
        return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
      },
      transformErrorResponse: (response, meta) => {
        const status = meta?.response?.status || response?.status;
        let message = "Failed to fetch schools";
        
        if (status === 422) {
          // Pydantic validation — detail is an array
          const detail = response?.data?.detail || response?.detail;
          if (Array.isArray(detail)) {
            const messages = detail.map((e) => e.msg || e.message || String(e));
            message = messages.join(", ");
          } else {
            message = detail?.msg || detail?.message || String(detail) || message;
          }
        } else {
          // HTTPException (502, 500, etc.) — detail is a string
          const detail = response?.data?.detail || response?.detail;
          message = typeof detail === "string" ? detail : detail?.message || message;
        }
        
        return {
          status: status || 500,
          message,
        };
      },
    }),
  }),
});

export const { useGetSchoolsQuery } = schoolsApi;
